// スムーススクロール
window.addEventListener('load', function() {
  const headerHeight = 105;

  document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const hash = this.getAttribute('href');
      const target = hash === '#' || hash === '' ? document.documentElement : document.querySelector(hash);

      if (!target) return;

      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });
});

window.addEventListener("load", function() {
  const headerHeight = 105;
  const urlHash = window.location.hash;

  if (urlHash) {
    const target = document.querySelector(urlHash);
    if (!target) return;

    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: 'instant'
    });
  }
});
